import { screenshotEditorController } from './screenshotEditorController'
import { ScreenshotEditorView } from './ScreenshotEditor'

export const ScreenshotEditor = screenshotEditorController(ScreenshotEditorView)



// WEBPACK FOOTER //
// ./src/components/ScreenshotEditor/index.js